import React, { useEffect, useRef, useState } from 'react';

import { useParams } from 'react-router-dom'
import SB_TitleBar from '../components/SB_TitleBar';
import SB_FinishLineBox from '../components/SB_FinishLineBox';
import SB_Tabs from '../components/SB_Tabs';
import SB_MessageBox from '../components/SB_MessageBox';
import { SpikerBoardContext, SpikerBoardContextI } from '../context/SpikerBoardContext';
import axios from 'axios';
import AppConfig from '../AppConfig';
import HPunchType from '../lib/HPunch';

export default function SSpikerBoard() {
    let { eventid } = useParams();
    const [spikerBoardContext, setSpikerBoardContext] = useState(new SpikerBoardContextI());
    const c_isLoaded = useRef(0);

    //on load board get all settings
    useEffect(() => {
        //load categories
        LoadData();
        //ConnectWS();
    }, []);

    useEffect(() => {
        //console.log("Current category spiker: " + boardData.startlist_activeCategoryID);
        console.log("BoardData changed:", JSON.stringify(spikerBoardContext));
        if (spikerBoardContext.event.ID > 0 && c_isLoaded.current == 0) {
            ConnectWS();
            c_isLoaded.current = 1;
        }
    }, [spikerBoardContext]);
    /*
    useEffect(() => {
        LoadFinishLine();
    }, [spikerBoardContext.event.ID])*/
    async function ConnectWS() {
        const socket = new WebSocket(AppConfig().WebSockets.Hostname + "?eventId=" + eventid);
        socket.addEventListener("open", (event) => {
            console.log("WS> Connection established");
            var p = {
                packet: "GET_FINISH_LINE",
                data: {}
            }
            socket.send(JSON.stringify(p));
        });
        socket.addEventListener("message", (event) => {
            //console.log("WS> onMessage: " + event.data);
            try {
                var json = JSON.parse(event.data);
                var packet = json.packet;
                //console.log("WS> onMessage, packet " + packet);
                if (packet == "FINISH_LINE_RESULTS") {
                    //console.log("WS> onMessage, packet " + packet);
                    var n = { ...spikerBoardContext };
                    n.c_FinishLinePunchesRef = json.data;
                    setSpikerBoardContext(n);
                }
            } catch (exc) {
                console.log("WS error");
            }
        });
        socket.addEventListener("close", (event) => {
            console.log("WS ERROR - closes/ disconnect");
            ConnectWS();
        })
    }
    async function LoadData() {
        var tmpSpikerBoardContext = { ...spikerBoardContext };//new SpikerBoardContextI();
        const headers = {
            'Content-Type': 'text/json; charset=UTF-8'
        }
        await axios.get(AppConfig().Server.Hostname + "/categories?eid=" + eventid, null, { headers }).then(
            (resp) => {
                tmpSpikerBoardContext.categories = resp.data;
                //console.log("set categories... ", resp.data);
            }
        );
        await axios.get(AppConfig().Server.Hostname + "/events?id=" + eventid, null, { headers }).then(
            (resp) => {
                tmpSpikerBoardContext.event = resp.data[0];
                //console.log(resp.data);
            }
        );
        tmpSpikerBoardContext.eventSettings.starttime = "11:30:00";
        setSpikerBoardContext(tmpSpikerBoardContext);
        //ConnectWS();
    }
    async function LoadFinishLine() {
        if (spikerBoardContext.event.ID < 0) return;
        const headers = {
            'Content-Type': 'text/json; charset=UTF-8'
        }
        console.log(AppConfig().Server.Hostname + "/punches?eid=" + spikerBoardContext.event.ID + "&filter_type=" + HPunchType.Finish);
        axios.get(AppConfig().Server.Hostname + "/punches?eid=" + spikerBoardContext.event.ID + "&filter_type=" + HPunchType.Finish, null, { headers }).then(
            (resp) => {
                var n = { ...spikerBoardContext }
                n.c_FinishLinePunchesRef = resp.data;
                console.log(resp.data);
                setSpikerBoardContext(n);
            }
        ).catch((err) => {
            //console.log(err);
        });
    }
    return (
        <SpikerBoardContext.Provider value={[spikerBoardContext, setSpikerBoardContext]} >
            <div className="grid grid-cols-12 gap-2 h-full p-2">
                <div className="col-span-9">
                    <div className="flex h-full flex-col gap-2" >
                        <SB_TitleBar />
                        <SB_Tabs />
                    </div>
                </div>
                <div className="col-span-3">
                    <div className="flex h-full flex-col gap-2">
                        <div className="h-2/3">
                            <SB_FinishLineBox />
                        </div>
                        <div className="flex-1">
                            <SB_MessageBox />
                        </div>
                    </div>
                </div>
            </div >
        </ SpikerBoardContext.Provider>
    )
}